// Warning: this will be re-generated on CI server
export const APP_VERSION: string = "1.1.7";
export const APP_BUILD_NUMBER: string = "4903";
export const APP_BUILD_TIME: number = 1793888293364;
export const APP_GIT_COMMIT: string = "f49bf361";
export const APP_GIT_BRANCH: string = "develop";
